import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Planzone, ProjectPortfolio } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  portfolios: Identifiable<ProjectPortfolio>[];
  retrieveProjectPortfolios(
    request: Boundaries["retrieveProjectPortfolios"]["request"],
  ): void;
}

function useRetrieveProjectPortfolios(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isRetrieveProjectPortfoliosRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isRetrieveProjectPortfoliosRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isRetrieveProjectPortfoliosRequestFailure,
    ),
    portfolios: useSelector(selector.getProjectPortfolios),
    retrieveProjectPortfolios: core.retrieveProjectPortfolios,
  };
}

export { useRetrieveProjectPortfolios };
